import { render, staticRenderFns } from "./ProjectSiteTemplateViewForm.vue?vue&type=template&id=06318867"
import script from "./ProjectSiteTemplateViewForm.vue?vue&type=script&lang=js"
export * from "./ProjectSiteTemplateViewForm.vue?vue&type=script&lang=js"
import style0 from "./ProjectSiteTemplateViewForm.vue?vue&type=style&index=0&id=06318867&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports